import { RadioGroup } from "@headlessui/react";
import { IconCheckbox } from "@tabler/icons";
import { PaymentMethod } from "./usePayment";
import { useTranslation } from "next-i18next";
import { useColors } from "../../../../../hooks/colors/useColors";

export function PaymentOption(props: {
  method: PaymentMethod;
  checked: boolean;
}) {
  const { method, checked } = props;
  const { i18n } = useTranslation("common");
  const { colors } = useColors();
  return (
    <RadioGroup.Option
      // style={{ backgroundColor: colors.white }}
      key={method.name}
      value={method}
      style={{
        background: checked ? colors.primary : colors.gray,
        opacity: checked ? 1 : 0.6,
      }}
      className={({ active }) =>
        `${
          checked ? "!text-white" : "bg-slate-400"
        } relative flex cursor-pointer rounded-lg px-5 py-4 shadow-md focus:outline-none`
      }
    >
      {({ active }) => (
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-4">
            {checked && <IconCheckbox size="2rem" className="text-white" />}
            <div className="text-sm">
              <RadioGroup.Label
                as="p"
                className={`font-bold text-xl ${
                  checked ? "!text-white" : "!text-gray-800"
                }`}
              >
                {method.translate ? i18n.t(method.name) : method.name}
              </RadioGroup.Label>
            </div>
          </div>
          {<div>{method.icon}</div>}
        </div>
      )}
    </RadioGroup.Option>
  );
}
